import { render, staticRenderFns } from "./VejezAnticipada.vue?vue&type=template&id=0d812094&scoped=true"
import script from "./VejezAnticipada.vue?vue&type=script&lang=ts"
export * from "./VejezAnticipada.vue?vue&type=script&lang=ts"
import style0 from "./VejezAnticipada.vue?vue&type=style&index=0&id=0d812094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d812094",
  null
  
)

export default component.exports